import { MyStore } from 'kts-platform-frame/redux';

export default function () {
    let key: string | null = null;
    const pathname = window.location.pathname;
    const appMap = MyStore.instance.getState().config.appList.map;

    appMap.forEach((e, k) => {
        if (pathname.indexOf(e.URL) === 0) {
            key = k;
        }
    });

    if (key === null) {
        const arr = pathname.split('/workbench/m/');
        if (arr.length > 1) {
            key = (arr.pop() || '').split('/')[0];
        }
    }

    return key;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/getAppKey/index.ts